import { removeLocalStorage, writeLocalStorage } from "src/common/util/localStorage";

const STORAGE_PREFIX = "scenaria-context-prefs:";

export const SCENARIA_MANDATORY_LAYERS = ["humanPrompt"] as const;

export const SCENARIA_OPTIONAL_LAYERS = ["personalContext", "orgContext"] as const;

export type ScenariaOptionalLayer = typeof SCENARIA_OPTIONAL_LAYERS[number];

const keyFor = (userId: number | string): string => `${STORAGE_PREFIX}${userId}`;

export const getExcludedScenariaLayers = (userId: number | string): ScenariaOptionalLayer[] => {
  try {
    const raw = localStorage.getItem(keyFor(userId));
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (v): v is ScenariaOptionalLayer =>
        typeof v === "string" && (SCENARIA_OPTIONAL_LAYERS as readonly string[]).includes(v),
    );
  } catch {
    return [];
  }
};

export const setExcludedScenariaLayers = (
  userId: number | string,
  excluded: ScenariaOptionalLayer[],
): void => {
  const unique = Array.from(new Set(excluded)).filter((v) =>
    (SCENARIA_OPTIONAL_LAYERS as readonly string[]).includes(v),
  );
  if (unique.length === 0) {
    removeLocalStorage(keyFor(userId));
  } else {
    writeLocalStorage(keyFor(userId), JSON.stringify(unique));
  }
};
